import type { ICGTemplateVariation } from '~/modules/campaign-template/types';
import type { ICampaignGroup } from '~/modules/campaign-group/types';

import {
  GCampaignTable,
  useGCampaignTableCellContext,
  useGCampaignTableContext,
} from '~/presentation/common';
import { CGTemplateVariantProperty } from './CGTemplateVariantProperty';
import { IVariantType } from '~/modules/campaign/types';

const GROUP_VARIATIONS: ICGTemplateVariation[] = [
  {
    isOrigin: true,
    variantKey: IVariantType.VARIANT_A,
    name: 'Control group',
  },
  {
    isOrigin: false,
    variantKey: IVariantType.VARIANT_B,
    name: 'Variant group',
  },
];

interface CGTemplateVariantRenderProps {
  campaignGroup: ICampaignGroup;
}

export const CGTemplateVariantRender: React.FC<CGTemplateVariantRenderProps> = ({
  campaignGroup,
}) => {
  const { item, columnIndex } = useGCampaignTableCellContext();
  const { parsePaddingRow } = useGCampaignTableContext();

  return (
    <GCampaignTable.Cell index={columnIndex}>
      {GROUP_VARIATIONS.map((variant, rowIndex) => {
        const isHideRow = item.flushRowIndex !== undefined && rowIndex > item.flushRowIndex;
        if (isHideRow) return null;

        return (
          <GCampaignTable.Cell
            key={`variant-cell-${rowIndex}`}
            index={columnIndex}
            padding={parsePaddingRow(columnIndex)}
          >
            <CGTemplateVariantProperty campaignGroup={campaignGroup} variant={variant} />
          </GCampaignTable.Cell>
        );
      })}
    </GCampaignTable.Cell>
  );
};
